// extracted by mini-css-extract-plugin
module.exports = {"button-edit-avaliacao":"style_button-edit-avaliacao__3h4-f"};